import $ from 'jquery';

var homeownerResources = {
    initHomeownerResources: function(){

    var selectedCategory = 'All_Categories';
    var selectedState = 'All_States';
    var mostRecentlyAddedElement = 1;
    var viewMorePressed = false;

    const BATCH_SIZE = 8;
    var toArticle = BATCH_SIZE;

    $(function () {
        setFocus();
    });

    function setFocus() {
        $(document).keydown(function (e) {
            if (e.which == 9) {
                if (viewMorePressed) {
                    e.preventDefault();
                    $(".msh-resources-block_list .msh-resources-block_list-content:nth-child(" + mostRecentlyAddedElement + ") .h4 a").focus();
                    viewMorePressed = false;
                }
            }
        });
    }

    $('#category-dropdown').change(function () {
        selectedCategory = $('#category-dropdown').val();

        // When we update the filters first thing first we reset the range
        toArticle = BATCH_SIZE;

        sendFiltersToBE(selectedCategory, selectedState, toArticle);

    });
    $('#state-dropdown').change(function () {

        selectedState = $('#state-dropdown').val();

        // When we update the filters first thing first we reset the range
        toArticle = BATCH_SIZE;

        sendFiltersToBE(selectedCategory, selectedState, toArticle);
    });
    $(".msh-resources-block_list").on("click", "#view-more", function () {
        toArticle += BATCH_SIZE;

        sendFiltersToBE(selectedCategory, selectedState, toArticle);
    });

    function sendFiltersToBE(selectedCategory, selectedState, toArticle) {

        // Show the Loader
        window.showPreLoader();

        mostRecentlyAddedElement = $('.msh-resources-block_list-content').length + 1;
        var url = "/HomeownerResourceLanding/FilterArticles";
        //'@Url.Action("FilterArticles", "HomeownerResources")'
        $.get(url, { selectedCategory: selectedCategory, selectedState: selectedState, toArticle: toArticle }, function (data) {
        
            $(".msh-resources-block_list-content").remove();
            $("#view-more").remove();
            $("#no-result").remove();
            

            $(".msh-resources-block_list").append(data);

            if (toArticle > 8) // We are here because of View More
            {
                viewMorePressed = true;
                setFocus();
            }

            // Hide the loader
            window.hidePreLoader();
            window.initPreLoader();
        });
    }

    }
};


$(function(){
    // Attach listener on lot dropdown
    let homeownerResourcesPage = $(".homeowner-resources");
    if( homeownerResourcesPage && homeownerResourcesPage.length > 0 ) 
    {
        homeownerResources.initHomeownerResources();
    }
    
});

export default homeownerResources;